/* Novera: ficha ampliada dentro de la página del producto. */
(() => {
  if (window.__nvSummaryDialogReady) return;
  window.__nvSummaryDialogReady = true;
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-nv-summary-open]');
    if (opener) {
      const container = opener.closest('.nv-pdp-summary-wrap');
      const dialog = container?.querySelector('.nv-pdp-summary-dialog');
      if (dialog && !dialog.open && typeof dialog.showModal === 'function') {
        dialog.showModal();
        dialog.querySelector('[data-nv-summary-close]')?.focus();
      }
      return;
    }
    const closer = event.target.closest('[data-nv-summary-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog?.open) dialog.close();
    }
  });
})();
